import defaultMock from '../../language_assessment/examMockConfig';

const examMockConfig = { ...defaultMock, title: 'ASSESS-1624_TESTER' };

export default examMockConfig;
